// extracted by mini-css-extract-plugin
export default {"emailContainer":"EmailTemplate_emailContainer__U7L7D","emailContent":"EmailTemplate_emailContent__Ad6ug"};